import { SortOption } from "components/DropdownSelectors/GenericSingleSelector/GenericSort"

export type UserApiResponse = {
    id: string
    createdAt?: string
    cognitoId: string
    email: string
    firstName: string
    lastName: string
    gender?: string
    dateOfBirth?: string
    street1?: string
    street2?: string
    zip?: string
    city?: string
    state?: string
    country?: string
    phone?: string
    imageUrl?: string
    preferredLanguage?: string
    timezone?: string
    roles?: Record<string, string>[]
}

export type User = {
    id?: string
    cognitoId?: string
    email: string
    first_name: string
    last_name: string
    gender?: string
    street_1?: string
    street_2?: string
    zip?: string
    country?: string
    phone?: string
    image_url?: string
    lang?: string
    timezone?: string
}

export function mapUserFromDTO(user: UserApiResponse): User {
    return ({
        id: user.id,
        cognitoId: user.cognitoId,
        email: user.email,
        first_name: user.firstName,
        last_name: user.lastName,
        gender: user.gender,
        street_1: user.street1,
        street_2: user.street2,
        zip: user.zip,
        country: user.country,
        phone: user.phone,
        image_url: user.imageUrl,
        lang: user.preferredLanguage,
        timezone: user.timezone
    })
}

export type SignupApiRequest = {
    email: string,
    password: string,
    given_name: string,
    family_name: string,
}

export const SORT_USER_LAST_NAME_ASC: SortOption = {tag: "common.sort_by_last_name_asc", sort_query: "user.lastName,asc", icon:"feather-arrow-up text-xl mr-4"}
export const SORT_USER_LAST_NAME_DESC: SortOption = {tag: "common.sort_by_last_name_desc", sort_query: "user.lastName,desc", icon:"feather-arrow-down text-xl mr-4"}
export const SORT_USER_FIRST_NAME_ASC: SortOption = {tag: "common.sort_by_first_name_asc",sort_query: "user.firstName,asc", icon:"feather-arrow-up text-xl mr-4"}
export const SORT_USER_FIRST_NAME_DESC: SortOption = {tag: "common.sort_by_first_name_desc",sort_query: "user.firstName,desc", icon:"feather-arrow-down text-xl mr-4"}
export const LOCAL_STORAGE_CLIENT_SORT = 'client_sort'